module.exports = __webpack_public_path__ + "img/banner_new_index.b32dcdc7.jpg";